import React, { useState, useEffect } from 'react';

const Iocdf = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/posts?tags=8');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);
  const toggleButtons = document.querySelectorAll('.close');
  const hiddenContent = document.querySelector('.overlay');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      hiddenContent.classList.remove('show');
    });
  });
  return (
    <div className='news-iocd'>
      {/* {pages.map((page) => {
        console.log('page: ', page);
        return (
        <div className='articles'>
          <h2>{page.title.rendered}</h2>
          <div className='article' dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        </div>
      )
      })} */}

        <div className='links'>
        <h2>IOCDF NEWS</h2>
        <ul>
          <li><a href='iocdf.org/blog/2024/05/09/an-open-letter-to-my-doctor-from-the-moms-with-ocd-special-interest-group/'>“An Open Letter to my Doctor” from the Moms with OCD Special Interest Group</a></li>
          <li><a href='https://iocdf.org/blog/2024/05/08/when-my-ocds-worst-case-scenario-came-true/'>When My OCD’s Worst Case Scenario Came True</a></li>
          <li><a href='https://iocdf.org/blog/2024/04/30/spectrum-designs-a-partner-empowering-through-employment/'>Spectrum Designs: A Partner Empowering Through Employment</a></li>
          <li><a href='https://iocdf.org/blog/2024/04/26/attending-ocdcon-saving-your-orlandough/'>Attending #OCDCon: Saving your ORLAN(DOUGH) $ </a></li>
          <li><a href='https://iocdf.org/blog/2024/04/24/the-time-ocd-came-to-visitand-didnt-leave/'>The Time OCD came to visit…and didn’t leave…</a> </li>
        </ul>
        </div>
    </div>    
  );
}

export default Iocdf;